class DashboardData {
  constructor(data) {
    this.todayStats = data.todayStats || {
      totalTasks: 0,
      completedTasks: 0,
      upcomingTasks: 0,
      overdueTasks: 0
    };
    
    this.weekStats = data.weekStats || {
      totalTasks: 0,
      completedTasks: 0,
      completionRate: 0,
      averageTasksPerDay: 0
    };
    
    this.categoryDistribution = data.categoryDistribution || [];
    
    this.priorityDistribution = data.priorityDistribution || {
      high: 0,
      normal: 0
    };
    
    this.recentlyCompleted = data.recentlyCompleted || [];
    
    this.upcomingTasks = data.upcomingTasks || [];
  }

  static fromJson(json) {
    return new DashboardData({
      todayStats: {
        totalTasks: json.today_stats?.total_tasks || 0,
        completedTasks: json.today_stats?.completed_tasks || 0,
        upcomingTasks: json.today_stats?.upcoming_tasks || 0,
        overdueTasks: json.today_stats?.overdue_tasks || 0
      },
      
      weekStats: {
        totalTasks: json.week_stats?.total_tasks || 0,
        completedTasks: json.week_stats?.completed_tasks || 0,
        completionRate: json.week_stats?.completion_rate || 0,
        averageTasksPerDay: json.week_stats?.average_tasks_per_day || 0
      },
      
      categoryDistribution: (json.category_distribution || []).map(category => ({
        id: category.category_id,
        name: category.name,
        color: category.color,
        taskCount: category.task_count,
        completedCount: category.completed_count,
        completionRate: category.completion_rate
      })),
      
      priorityDistribution: {
        high: json.priority_distribution?.high || 0,
        normal: json.priority_distribution?.normal || 0
      },
      
      recentlyCompleted: (json.recently_completed || []).map(task => ({
        id: task.id,
        title: task.title,
        completedAt: new Date(task.completed_at),
        categoryName: task.category_name,
        categoryColor: task.category_color
      })),
      
      upcomingTasks: (json.upcoming_tasks || []).map(task => ({
        id: task.id,
        title: task.title,
        dueDate: task.due_date ? new Date(task.due_date) : null,
        categoryName: task.category_name,
        categoryColor: task.category_color,
        priority: task.priority
      })),
    });
  }

  getCategoryChartData() {
    return {
      labels: this.categoryDistribution.map(category => category.name),
      datasets: [{
        data: this.categoryDistribution.map(category => category.taskCount),
        backgroundColor: this.categoryDistribution.map(category => category.color),
        borderWidth: 1
      }]
    };
  }

  getPriorityChartData() {
    return {
      labels: ['High', 'Normal'],
      datasets: [{
        data: [this.priorityDistribution.high, this.priorityDistribution.normal],
        backgroundColor: ['#dc3545', '#6c757d'],
        borderWidth: 1
      }]
    };
  }

  getCategoryCompletionRates() {
    return this.categoryDistribution.map(category => ({
      name: category.name,
      completionRate: Math.round(category.completionRate),
      color: category.color
    })).sort((a, b) => b.completionRate - a.completionRate);
  }
}

export default DashboardData; 